import React, { useEffect, useState } from 'react'
import ReCAPTCHA from 'react-google-recaptcha';
import { doGET } from '../../util/HttpUtil';
import Skeleton from 'react-loading-skeleton';
import { buildAutomationChildTestId, resolveAutomationTestId } from '../../components/InputField/testId';
const GCaptchaStyle = { minHeight: "74px", backgroundColor: "#f9f9f9", border: "1px solid #d3d3d3" };
const GCaptcha = ({ onChange, onExpired, testId }) => {

    const [siteKey, setSiteKey] = useState("");
    const [loading, setLoading] = useState(true);
    const resolvedTestId = resolveAutomationTestId(testId);

    const getCaptcha = async () => {
        setLoading(true)
        try {
            const response = await doGET("/api/sys-config/googleSiteKey/detail", true);
            if (response?.status === 200) {
                setSiteKey(response.data?.googleSiteKey ?? "");
            }
            setLoading(false)
        } catch (error) {
            setLoading(false)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        getCaptcha()
    }, [])

    if (loading) {
        return <div
            className='w-100 fw-500 font-size-14 d-flex justify-content-center align-items-center'
            style={GCaptchaStyle}
            data-testid={resolvedTestId}
        >
            <Skeleton baseColor='#f3f3f3' highlightColor='#e8e8e8' height={74} data-testid={buildAutomationChildTestId(resolvedTestId, "loading")} />
        </div>
    }

    if (!siteKey) {
        return <div
            className='fw-500 font-size-14 d-flex justify-content-center align-items-center px-5 '
            style={GCaptchaStyle}
            data-testid={resolvedTestId}
        >
            <span data-testid={buildAutomationChildTestId(resolvedTestId, "error")}>Failed to load Captcha</span>
        </div>
    }

    return <div style={{ minHeight: "74px" }} data-testid={resolvedTestId}>
        <div data-testid={buildAutomationChildTestId(resolvedTestId, "challenge")}>
        <ReCAPTCHA
            sitekey={siteKey}
            onChange={onChange}
            onExpired={onExpired}
        />
        </div>
    </div>

}

export default GCaptcha
